import React from 'react';
interface NavItemProps {
  id: string;
  label: string;
  isActive: boolean;
  onClick: (id: string) => void;
}
function NavItem({
  id,
  label,
  isActive,
  onClick
}: NavItemProps) {
  return <button onClick={() => onClick(id)} className={`w-full text-left block px-4 py-2 text-sm transition-colors ${isActive ? 'text-[#0B5FA5] border-l-4 border-[#0B5FA5] bg-blue-50/50 font-medium' : 'text-gray-600 hover:text-[#0B5FA5] hover:bg-blue-50/30 border-l-4 border-transparent'}`} data-id="element-245">
      {label}
    </button>;
}
interface NavCategoryProps {
  title: string;
  children: React.ReactNode;
}
function NavCategory({
  title,
  children
}: NavCategoryProps) {
  return <div className="mt-6" data-id="element-246">
      <h3 className="px-4 text-xs font-bold text-gray-900 uppercase tracking-wider mb-2" data-id="element-247">
        {title}
      </h3>
      <div className="space-y-0.5" data-id="element-248">{children}</div>
    </div>;
}
interface SidebarProps {
  activePage: string;
  onNavigate: (pageId: string) => void;
}
export function Sidebar({
  activePage,
  onNavigate
}: SidebarProps) {
  return <aside className="w-[260px] flex-shrink-0 border-r border-gray-200 bg-[#F8FAFC] flex flex-col h-screen sticky top-0 overflow-y-auto" data-id="element-249">
      <nav className="flex-1 py-6 pb-12" data-id="element-250">
        <div className="space-y-0.5" data-id="element-251">
          <NavItem id="overview" label="Overview" isActive={activePage === 'overview'} onClick={onNavigate} data-id="element-252" />
          <NavItem id="getting-started" label="Getting Started" isActive={activePage === 'getting-started'} onClick={onNavigate} data-id="element-253" />
        </div>

        <NavCategory title="Integration Types" data-id="element-254">
          <NavItem id="checkout" label="<<checkout>>" isActive={activePage === 'checkout'} onClick={onNavigate} data-id="element-255" />
          <NavItem id="hosted-session" label="<<hostedSession>>" isActive={activePage === 'hosted-session'} onClick={onNavigate} data-id="element-256" />
          <NavItem id="direct-payment" label="<<directPayment>>" isActive={activePage === 'direct-payment'} onClick={onNavigate} data-id="element-257" />
          <NavItem id="batch-integration" label="Hosted <<batchIntegration>>" isActive={activePage === 'batch-integration'} onClick={onNavigate} data-id="element-258" />
          <NavItem id="mobile-integration" label="Mobile Integration" isActive={activePage === 'mobile-integration'} onClick={onNavigate} data-id="element-259" />
          <NavItem id="shopping-cart" label="Shopping Cart Plugin" isActive={activePage === 'shopping-cart'} onClick={onNavigate} data-id="element-260" />
        </NavCategory>

        <NavCategory title="Other Features" data-id="element-261">
          <NavItem id="payment-methods" label="Payment Methods" isActive={activePage === 'payment-methods'} onClick={onNavigate} data-id="element-262" />
          <NavItem id="security" label="Security and Fraud Prevention" isActive={activePage === 'security'} onClick={onNavigate} data-id="element-263" />
          <NavItem id="features" label="Features" isActive={activePage === 'features'} onClick={onNavigate} data-id="element-264" />
        </NavCategory>

        <NavCategory title="API Implementation" data-id="element-265">
          <NavItem id="server-api" label="Making a Server API Request" isActive={activePage === 'server-api'} onClick={onNavigate} data-id="element-266" />
          <NavItem id="multiple-sources" label="Using Multiple Payment Sources" isActive={activePage === 'multiple-sources'} onClick={onNavigate} data-id="element-267" />
          <NavItem id="js-libraries" label="JavaScript Libraries" isActive={activePage === 'js-libraries'} onClick={onNavigate} data-id="element-268" />
        </NavCategory>

        <NavCategory title="Resources" data-id="element-269">
          <NavItem id="announcements" label="Announcements" isActive={activePage === 'announcements'} onClick={onNavigate} data-id="element-270" />
          <NavItem id="glossary" label="Glossary" isActive={activePage === 'glossary'} onClick={onNavigate} data-id="element-271" />
        </NavCategory>
      </nav>
    </aside>;
}